import {ajax} from '@clouderwork/ywk'
import wx from 'weixin-js-sdk'

// 微信分享
export const initConfig = () => {
  let locas = window.location.href
  let currentLocal = locas.split('#')[0]
  ajax.postJson('https://info.clouderwork.com/wechat/jssdk', { url: currentLocal }).then((res) => {
    if (res && res.signature) {
      wx.config({
        debug: false,
        appId: res.appId,
        timestamp: res.timestamp,
        nonceStr: res.nonceStr,
        signature: res.signature,
        // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        jsApiList: [
          'previewImage',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone'
        ], 
        openTagList: [
          'wx-open-launch-app'
        ]
      })
    }
  })
}

let shareConfig = {
  title: '招聘有礼，限时福利！',
  desc: '边招人才边赚钱，高额平台奖励等你来拿！',
  link: encodeURI(window.location.href),
  imgUrl: 'https://cloudwork.oss-cn-beijing.aliyuncs.com/%E7%94%BB%E6%9D%BF.png'
}
export const weChatFn = (config = shareConfig) => {
  wx.ready(() => {
    wx.onMenuShareTimeline(config)
    wx.onMenuShareAppMessage(config)
    wx.onMenuShareQQ(config)
    wx.onMenuShareQZone(config)
    wx.onMenuShareWeibo(config)
  })
}
